import {Injectable} from '@angular/core';
import {merge} from 'lodash-es';
import {
    NebulaConfirmationDialogComponent
} from '@scientifica-cms-fe/services/confirmation/dialog/dialog.component';
import {NebulaConfirmationDialogConfig} from '@scientifica-cms-fe/services/confirmation/confirmation.types';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class NebulaConfirmationService {
    private _defaultConfig: NebulaConfirmationDialogConfig = {
        title: 'Confirm action',
        message: 'Are you sure you want to confirm this action?',
        icon: {
            show: true,
            name: 'heroicons_outline:exclamation',
            color: 'warn'
        },
        actions: {
            confirm: {
                show: true,
                label: 'Confirm',
                color: 'warn'
            },
            cancel: {
                show: true,
                label: 'Cancel'
            }
        },
        dismissible: false
    };

    /**
     * Constructor
     */
    constructor(
        private _matDialog: MatDialog
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    open(config: NebulaConfirmationDialogConfig = {}): MatDialogRef<NebulaConfirmationDialogComponent> {
        // Merge the user config with the default config
        const userConfig = merge({}, this._defaultConfig, config);

        // Open the dialog
        return this._matDialog.open(NebulaConfirmationDialogComponent, {
            autoFocus: false,
            disableClose: !userConfig.dismissible,
            data: userConfig,
            panelClass: 'fuse-confirmation-dialog-panel'
        });
    }
}
